import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Development Firebase Configuration
const firebaseConfigDev = {
    apiKey: "AIzaSyAtRjbZF0r25-VoGvdXfn5khtNpasyDL2A",
    authDomain: "outlet-78c2a.firebaseapp.com",
    databaseURL: "https://outlet-78c2a-default-rtdb.firebaseio.com",
    projectId: "outlet-78c2a",
    storageBucket: "outlet-78c2a.appspot.com",
    messagingSenderId: "421752824676",
    appId: "1:421752824676:web:cc95a5fc16c5900bf31071",
    measurementId: "G-0N33F9K7X2"
};


// Production Firebase Configuration
const firebaseConfigProd = {
    apiKey: "AIzaSyCTSuXA5WGe8oXZoAZtnGWHRvJHFygBizs",
    authDomain: "outlet-support.firebaseapp.com",
    databaseURL: "https://outlet-support-default-rtdb.firebaseio.com",
    projectId: "outlet-support",
    storageBucket: "outlet-support.appspot.com",
    messagingSenderId: "438847000826",
    appId: "1:438847000826:web:3fce5750fd0ee9116f7943",
    measurementId: "G-F1Y94YRGEY"
};

// Select configuration based on environment
const firebaseConfig = process.env.REACT_APP_ENV === 'production'
    ? firebaseConfigProd
    : firebaseConfigDev;

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;